import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobWaypointDisplayPipe } from './job-waypoint-display.pipe';
@NgModule({
  declarations: [JobWaypointDisplayPipe],
  imports: [CommonModule],
  exports: [JobWaypointDisplayPipe],
})
export class JobWaypointDisplayPipeModule {}
